import { Injectable } from '@angular/core';
import {
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpEventType
} from '@angular/common/http';
import { ReplaySubject, Observable } from 'rxjs';
import { switchMap, tap, catchError } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class RequestQueueService {
	private readonly queue: Array<ReplaySubject<any>> = [];

	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		const requestQueueItem$ = new ReplaySubject<any>();
		const result$ = requestQueueItem$.pipe(
			// switchMap and tap allows us to switch to the raw http response, but return the raw subject
			switchMap(() =>
				next.handle(request).pipe(
					tap((req) => {
						// Only process next request in queue if it's a response
						if (req.type === HttpEventType.Response) {
							this.processNextRequest();
						}
					}),
					// Or Error
					catchError((err) => {
						this.processNextRequest();
						throw err;
					})
				)
			)
		);

		// Queue up request
		this.queue.push(requestQueueItem$);

		if (this.queue.length <= 1) {
			this.dispatchRequest();
		}

		return result$;
	}

	private processNextRequest(): void {
		if (this.queue && this.queue.length) {
			// Remove first element in queue
			this.queue.shift();
		}
		this.dispatchRequest();
	}

	private dispatchRequest(): void {
		// Only emit next behavior subject in line if we have items left in queue
		if (this.queue.length) {
			const nextSub$ = this.queue[0];
			nextSub$.next(1);
			nextSub$.complete();
		}
	}
}
